module.exports = __webpack_public_path__ + "static/media/img160.75b016f3.jpg";